module.exports = __webpack_public_path__ + "images/6ffda5b1807a8d1d9f01687d49ce366f.svg";